// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_math from "rescript/lib/es6/js_math.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

function parseIntervalMsJs(raw) {
  if (raw === undefined) {
    return 30000;
  }
  var n = Belt_Int.fromString(raw);
  if (n !== undefined && n > 0) {
    return n;
  } else {
    return 30000;
  }
}

function parseIntervalMs(element) {
  var raw = element.getAttribute("data-interval-ms");
  if (raw == null) {
    return 30000;
  } else {
    return parseIntervalMsJs(raw);
  }
}

function formatRelativeAgoJs(atMs, nowMs) {
  var diffMs = Math.max(0, nowMs - atMs);
  var diffMins = Js_math.floor_int(diffMs / 60000);
  var diffHours = Js_math.floor_int(diffMs / 3600000);
  var diffDays = Js_math.floor_int(diffMs / 86400000);
  if (diffMins < 1) {
    return "just now";
  } else if (diffMins < 60) {
    return String(diffMins) + "m ago";
  } else if (diffHours < 24) {
    return String(diffHours) + "h ago";
  } else {
    return String(diffDays) + "d ago";
  }
}

function formatRelativeAgo(atMs) {
  return formatRelativeAgoJs(atMs, Date.now());
}

function setEmptyIfPresent(element) {
  var empty = element.getAttribute("data-empty");
  if (!(empty == null)) {
    element.textContent = empty;
    return ;
  }
  
}

function updateLabel(element) {
  var datetime = DomEl$GameDataCore.data(element, "datetime");
  var prefix = DomEl$GameDataCore.data(element, "prefix");
  if (datetime === "") {
    return setEmptyIfPresent(element);
  }
  var at = Date.parse(datetime);
  if (Number.isFinite(at)) {
    element.textContent = prefix + formatRelativeAgo(at);
    return ;
  } else {
    return setEmptyIfPresent(element);
  }
}

function clearTimer(self) {
  var timer = self.timer;
  if (!(timer == null)) {
    clearInterval(timer);
    return ;
  }
  
}

function startTimer(self) {
  var element = self.el;
  var intervalMs = parseIntervalMs(element);
  var timer = setInterval((function () {
          updateLabel(element);
        }), intervalMs);
  self.timer = timer;
}

function mounted() {
  var self = this ;
  var element = self.el;
  updateLabel(element);
  startTimer(self);
}

function updated() {
  var self = this ;
  clearTimer(self);
  var element = self.el;
  updateLabel(element);
  startTimer(self);
}

function destroyed() {
  var self = this ;
  clearTimer(self);
}

var relativeTime = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var defaultIntervalMs = 30000;

export {
  defaultIntervalMs ,
  parseIntervalMsJs ,
  parseIntervalMs ,
  formatRelativeAgoJs ,
  formatRelativeAgo ,
  setEmptyIfPresent ,
  updateLabel ,
  clearTimer ,
  startTimer ,
  mounted ,
  updated ,
  destroyed ,
  relativeTime ,
}
/* mounted Not a pure module */
